export default __webpack_public_path__ + "static/media/edit-button.a9ace2a6.svg";